import Vue from 'vue'
import router from '@/router'

export default {
  setPeopleId({ dispatch }: any, payload: any) {
    dispatch('changePeopleId', payload)
  },
  changePeopleId({ commit, state, dispatch }: any, payload: any) {
    console.log('changePeopleId', payload)
  }
}
